<template>
    <div
        v-click-outside-app="closeIsExportOpen"
        class="transactions-filter__exports h-100"
    >
        <div
            @click="toggleIsExportOpen"
            class="transactions-filter__button"
        >
            <span class="material-icons">
                get_app
            </span>
            Export
        </div>
        <transition name="fade">
            <div
                v-if="isExportOpen"
                class="transactions-filter-export-dropdown"
            >
                <export-transactions
                    :filter="filter"
                    class="d-flex flex-column mr-0 transactions-filter-export-dropdown__button-group"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import ExportTransactions from '@/components/common/ExportTransactions.vue'
import outsideClickMixin from '@/mixins/outsideClick.js'

export default {
    mixins: [outsideClickMixin],

    props: {
        filter: {
            required: true
        }
    },

    components: {
        ExportTransactions
    },

    data() {
        return {
            isExportOpen: false,
        }
    },

    methods: {
        toggleIsExportOpen() {
            this.isExportOpen = !this.isExportOpen
        },

        closeIsExportOpen() {
            this.isExportOpen = false
        }
    }
}
</script>
